
  export const CUSTOMERGOALS_RECEIVED = "CUSTOMERGOALS_RECEIVED";
  export const SET_CUSTOMERGOAL = "SET_CUSTOMERGOAL";
  export const CREATE_CUSTOMERGOAL = "CREATE_CUSTOMERGOAL";
  export const SET_PROPERTY_CUSTOMERGOAL = "SET_PROPERTY_CUSTOMERGOAL";
  